import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dashboard-scroll"
export default class extends Controller {
  static values = {
    speed: { type: Number, default: 10 },
    pauseDuration: { type: Number, default: 2000 }
  }

  connect() {
    // Check if dashboard query parameter is present
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.has('dashboard')) {
      return
    }

    this.element.classList.add('dashboard')
    this.scrolling = true
    this.startScrolling()
    this.currentScrollElement = 0
  }

  cloneContent() {
    // Clone the main content and append it for seamless infinite scroll
    const div = document.createElement('div')
    const oldDiv = document.getElementById(`activities-index-${this.currentScrollElement}`)
    div.innerHTML = oldDiv.innerHTML;
    // Remove the controller attribute from the clone to avoid double initialization
    this.currentScrollElement += 1;
    div.id = `activities-index-${this.currentScrollElement}`
    oldDiv.insertAdjacentElement('afterend', div);
    
    if(document.getElementById(`activities-index-${this.currentScrollElement - 2}`))
      document.getElementById(`activities-index-${this.currentScrollElement - 2}`).remove()
  }

  disconnect() {
    this.stopScrolling()
  }

  startScrolling() {
    this.scrollInterval = setInterval(() => {
      if (this.scrolling) {
        window.scrollBy(0, this.speedValue)

        const scrollHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight
        )

        // When we've reached the bottom, clone content and continue scrolling
        if ((window.innerHeight + window.scrollY) >= scrollHeight - 1) {
          this.cloneContent()
        }
      }
    }, 16) // ~60fps
    setInterval(() => window.location.reload(), 28800000)
  }


  stopScrolling() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval)
    }
  }
}
